<template>
  <base-draggable-modal
      name="create_field"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="create_field">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-text-field
                density="default"
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.name"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('name') }}<strong>*</strong></span>
              </template>
            </v-text-field>
            <v-autocomplete
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.field_type"
                :items="field_types"
                :return-object="false"
                item-value="value"
                item-title="text"
                hide-details
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('field_type') }}<strong>*</strong></span>
              </template>
            </v-autocomplete>
            <v-combobox
                v-if="record.field_type === 'select_single' || record.field_type === 'select_multiple'"
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.available_options"
                chips
                closable-chips
                hide-details
                clearable
                multiple>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('list_options') }}<strong>*</strong></span>
              </template>
            </v-combobox>
            <v-row class="mt-3">
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.mandatory"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('mandatory') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.show_in_search"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_in_search') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.show_in_portal"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_in_portal') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.show_on_creation"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_on_creation') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.show_on_update"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('show_on_update') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox style="float: left;" color="success" density="compact" hide-details v-model="record.editable_in_portal"/>
                <span class="pl-3 sm-normal" style="display: block; height: 40px; align-content: center;">{{ $store.getters.translate('editable_in_portal') }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="reset">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("close") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import BaseActionButton from "../../components/commonComponents/BaseActionButton.vue";
import {PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX,
  },
  data() {
    return {
      page: helpFunctions.pages.fields,
      record: {},
      field_types: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    load(selected_model) {
      this.record = {
        model_type: selected_model,
      };
      this.field_types = this.$lodash.sortBy(helpFunctions.field_types, 'text');
      this.openModal('create_field');
    },
    async save() {
      let usual_fields_required = [{name: 'name', mandatory: true}, {name: 'field_type', mandatory: true}];
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, usual_fields_required)) {
        //create translation
        let key = this.$lodash.lowerCase(this.record.name).replace(/ /g, "_");
        await helpFunctions.createModel(this.$toast, helpFunctions.pages.translations.name, { key: key, language: 'en', value: this.record.name });
        await this.$store.dispatch("refreshTranslations");
        //create field
        this.record.name = key;
        if(await helpFunctions.createModel(this.$toast, this.page.name, this.record)) {
          this.$emit('refresh');
          this.reset();
        }
      }
    },
    reset() {
      this.record = {};
      this.closeModal('create_field');
    },
  },
};
</script>